module.exports = __webpack_public_path__ + "static/media/digipak_inner.2bd8484b.jpg";